import template from './client-row.html';

const ClientRowComponent = {
    bindings: {
        client: '<',
        onDeleteClick: '&',
        onEditClick: '&',
        onOpenSurveyModal: '&',
        surveyStatus: '<'
    },
    template
};

export default ClientRowComponent;



// WEBPACK FOOTER //
// ./app/components/client-admin/client-row/client-row-component.js